import { render } from "./SubHeaderForm.vue?vue&type=template&id=431ed92c&ts=true"
import script from "./SubHeaderForm.vue?vue&type=script&lang=ts"
export * from "./SubHeaderForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/SubHeaderForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "431ed92c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('431ed92c', __exports__)) {
    api.reload('431ed92c', __exports__)
  }
  
  module.hot.accept("./SubHeaderForm.vue?vue&type=template&id=431ed92c&ts=true", () => {
    api.rerender('431ed92c', render)
  })

}


export default __exports__